module.exports = __webpack_public_path__ + "static/media/get-started-bg.ad722d41.png";